import {useLimsMaterials} from '@domain/materials'

import {useUrlParam} from '../../../routing'

export const useLimsMaterialsQuery = () => {
  const plantCode = useUrlParam('plantCode')
  return useLimsMaterials({plantCode})
}
